import React from 'react';
import { Form } from './components/Form';

function Contatti() {
  return (
    <section className="w-full h-full bg-white">
      <section className="relative bg-center bg-no-repeat bg-cover bg-[url(https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80)]">
        <div className="absolute inset-0 bg-black/75"></div>

        <div className="container relative max-w-screen-xl px-4 py-24 mx-auto sm:px-6 lg:px-8 lg:h-full lg:items-center lg:flex">
          <div className="mx-auto text-center text-white">
            <h1 className="text-5xl font-extrabold">Contattaci</h1>
            <p className="max-w-xl mt-4 sm:leading-relaxed sm:text-xl">
              Hai bisogno di metterti in contatto con noi? Compila il form qui
              in basso, ti risponderemo il prima possibile!
            </p>
          </div>
        </div>
      </section>
      <div className="container mx-auto">
        <div className="bg-white rounded-lg">
          <div className="grid grid-cols-1 gap-8 p-10 md:grid-cols-2 auto-rows-fr ">
            <div className="relative order-last p-10 bg-white md:order-first">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11329.88050263621!2d10.2621749!3d44.7712201!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa943e94a615370b1!2seDriveLAB%20s.r.l.!5e0!3m2!1sit!2sit!4v1674339160858!5m2!1sit!2sit"
                allowfullscreen=""
                className="absolute top-0 left-0 w-full h-full"
              ></iframe>
            </div>
            <div className="">
              <h3 className="mb-4 text-3xl text-center">Form di contatto</h3>
              <Form />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contatti;
